// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/draw\"},{\"path\":\"/register\"},{\"path\":\"/sentry-example-page\"},{\"path\":\"/success\"},{\"path\":\"/welcome-back\"}]}";globalThis["_sentryNextJsVersion"] = "15.5.0";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://b5ec83af9e5f9deb8cbf54cf77099cd5@o4509973459435520.ingest.us.sentry.io/4509973472083968",

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;